import uniq from "lodash/uniq";
import isEqual from "lodash/isEqual";
import * as uuid from "uuid";

import {COUNTERTOP_GROUP} from "../bvcomponents/kvComponent/core/constants";
import {USE_FAB_FILTERS_ONLY} from "../config";
import {hardCodeIsAmericanImport, hardCodeIsDeStefano, hardCodeIsFloform} from "./fabricatorHardcode";
import {getAllFeatureFilters, getFilterGroupValue, getFilterGroupValues, mergeFilterObjects} from "./utils";
import {getBvGroupFeatures, getBvGroupFilterValues} from "../api/server-api";
import {getCurrentLayout} from "../bvcomponents/appLayout";
import {getHardCodedFilterGroups} from "../bvcomponents/look/filtersHardcode";
import store from "../store";
import {updateFiltersCount} from "../actions/filtersFunctions";

/**
 * returns feature's background styles
 * @param f {object} fValue
 * @param isColor {boolean}
 * @returns {object}
 */
export const getFilterValueBackGround = (f, isColor = false) => {
  if (f.icon) {
    return {backgroundImage: `url(https://s3.amazonaws.com/filter-images/${f.icon})`}
  } else if (isColor && f.value) {
    return {backgroundColor: f.value}
  }
  return null
}

/**
 * returns feature' color filter value object
 * @param lookActiveFeature {object}
 * @param filterGroups {array}
 * @param colorFilterGroup {object}
 * @returns {object} feature' color filter value object
 */
export const getColorFilterValue = (lookActiveFeature, filterGroups, colorFilterGroup = null) => {
  if (!lookActiveFeature || !Array.isArray(filterGroups)) {
    return null
  }

  if (!colorFilterGroup) {
    colorFilterGroup = filterGroups.find(group => group.name === "Color");
  }

  if (!colorFilterGroup) {
    return null
  }

  const activeFeatureValues = getFilterGroupValues(lookActiveFeature, colorFilterGroup);

  // console.log("activeFeatureValues", activeFeatureValues);

  if (!Array.isArray(activeFeatureValues) || !activeFeatureValues.length) {
    return null
  }

  return getFilterGroupValue(activeFeatureValues[0], colorFilterGroup);
}

export const setActivePartFilterValues = (filterValuesArray, activePart, filterGroups) => {
  console.log("filterValuesArray from backend:", filterValuesArray);
  if ((COUNTERTOP_GROUP.includes(activePart.partId) || activePart.partId === "vanity_countertop")
    && filterValuesArray && !USE_FAB_FILTERS_ONLY) {
    let availableCountertopGroupFilters = ["color", "stone color", "collection", "manufacturer", "countertop material", "stone finish", "color group"]
    if (activePart.partId === "backsplash") {
      availableCountertopGroupFilters.push("material");
    }
    if (document.kvConfig.userId === 141822) { // https://asw.quotekitchenandbath.com/kitchen#/
      availableCountertopGroupFilters.push("material thickness");
      availableCountertopGroupFilters.push("promotional discounts");
      availableCountertopGroupFilters.push("color group");
    }
    if (document.kvConfig.userId === 138452) { // https://cutting_edge_countertops.quotekitchenandbath.com/kitchen#/
      availableCountertopGroupFilters.push("price group");
    }
    if (document.kvConfig.userId === 252141) { // https://solidsurface.quotekitchenandbath.com/visualizer#/
      availableCountertopGroupFilters.push("price");
    }
    if (window.location.href.includes("isfa")) { // https://isfa.quotekitchenandbath.com/kitchen?mode=dashboard&p=208659&language=en-US#/visualizer
      availableCountertopGroupFilters.push("color temperature");
    }
    if (hardCodeIsDeStefano()) { // https://de_stefano_new.quotekitchenandbath.com/kitchen#/
      availableCountertopGroupFilters = availableCountertopGroupFilters.filter(f => f === "manufacturer");
    }
    if (hardCodeIsFloform()) {
      availableCountertopGroupFilters = availableCountertopGroupFilters.filter(f => f !== "stone color");
    }
    const allFilterGroups = filterGroups.filter(filterGroup => {
      if (window.location.href.includes("porcelanosa")) {  // show all filters on https://porcelanosa_new.quotekitchenandbath.com/kitchen#/ except Edge
        return filterGroup.name && !filterGroup.name.includes("Edge")
      }
      // if (USE_FAB_FILTERS_ONLY) {
      //   if (!Array.isArray(filterGroup.values) || !filterGroup.values.length) {
      //     return false
      //   }
      //   if (filterGroup.values.filter(fgValue => fgValue.isFabricatorCustomFilter)) {
      //     return true
      //   }
      // }
      return filterGroup && filterGroup.name && availableCountertopGroupFilters.includes(filterGroup.name.trim().toLowerCase())
    });
    filterValuesArray = filterValuesArray.filter(filterId => {
      return allFilterGroups.some(filterGroup => filterGroup.values && filterGroup.values.some(filterValueObject => {
        return filterValueObject.id === filterId
      }))
    });
  }
  if (activePart.allFeaturesReceived && hardCodeIsAmericanImport()) {
    activePart.features.forEach(feature => {
      ["filterValueIDs", "fabFilterValueIDs"].forEach(key => {
        if (feature.dbFeature[key]) {
          Object.keys(feature.dbFeature[key]).forEach(filterGroupId => {
            const filterValues = feature.dbFeature[key][filterGroupId];
            if (Array.isArray(filterValues)) {
              filterValues.forEach(filterValueId => {
                if (!filterValuesArray.includes(filterValueId)) {
                  filterValuesArray.push(filterValueId)
                }
              })
            }
          })
        }
      })
    })
    console.log("filterValuesArray from features:", filterValuesArray);
  }
  activePart.filtersReceived = filterValuesArray;
};



/**
 * returns all available filter groups with values for navItems
 * @param navItems {array}
 * @param allFilterGroups {array}
 * @returns {array}
 */
export const getAvailableFiltersForNavItems = (navItems, allFilterGroups) => {
  let filterGroups = [];
  for (let i = 0; i < navItems.length; i++) {
    const checkFeature = navItems[i].part;
    let featureFilters = getAllFeatureFilters(checkFeature);
    const featureOptions = navItems[i].colorOptions;
    if (Array.isArray(featureOptions) && featureOptions.length) {
      featureOptions.forEach((option) => {
        if (option.feature.dbFeature.id !== checkFeature.dbFeature.id) {
          const fOptions = getAllFeatureFilters(option.feature);
          featureFilters = mergeFilterObjects(featureFilters, fOptions)
        }
      });
    }
    Object.keys(featureFilters).forEach(key => {
      let existingFilterGroup = filterGroups.find(group => group.id === +key);
      const filterGroupFromAll = allFilterGroups.find(group => group.id === +key);
      if (!existingFilterGroup) {
        if (filterGroupFromAll) {
          existingFilterGroup = Object.assign({}, filterGroupFromAll, {values: []});
          filterGroups.push(existingFilterGroup);
        }
      }
      if (existingFilterGroup) {
        const currentFilterValues = featureFilters[existingFilterGroup.id];
        if (Array.isArray(currentFilterValues)) {
          currentFilterValues.forEach(filterValueId => {
            if (!existingFilterGroup.values.some(fValue => fValue.id === filterValueId) && filterGroupFromAll) {
              const fValue = getFilterGroupValue(filterValueId, filterGroupFromAll);
              if (fValue) {
                existingFilterGroup.values.push(fValue)
              }
            }
          })
        }
      }
    })
  }
  return filterGroups
}

/**
 * returns all available filter groups with values for received from backend filters
 * @param featureGroup {featureGroupInterface}
 * @param allFilterGroups {[filterGroup]}
 * @returns {array}
 */
export const getAvailableFiltersForReceivedFilters = (featureGroup, allFilterGroups) => {
  let filterGroups = [];
  for (let i = 0; i < allFilterGroups.length; i++) {
    const filterGroup = allFilterGroups[i];
    for (let k = 0; k < filterGroup.values.length; k++) {
      const filterValue = filterGroup.values[k];
      if (featureGroup.filtersReceived.includes(filterValue.id)) {
        let existingFilterGroup = filterGroups.find(group => group.id === filterGroup.id);
        if (!existingFilterGroup) {
          existingFilterGroup = Object.assign({}, filterGroup, {values: []});
          filterGroups.push(existingFilterGroup);
        }
        if (!existingFilterGroup.values.some(fValue => fValue.id === filterValue.id)) {
          existingFilterGroup.values.push(filterValue)
        }
      }
    }
  }
  return filterGroups
}

export const checkIfNeedToReceiveFeaturesIfFiltersApplied = (selectedFilters, currentParent, onScroll = false) => {
  if (currentParent.getRealFeaturesReceivedProperty()) { // all features received, why do we need to request more?
    return false
  }
  let arrayOfNeededFiltersToReceive = uniq(  // remove duplicates
    selectedFilters.map(filterObj => filterObj.filterId)
  );
  if (currentParent.filterIdsReceived) {
    // make one object with one filter in array (since we don't need to make request with several filters)
    arrayOfNeededFiltersToReceive = arrayOfNeededFiltersToReceive.filter((filterValue) => {
      return !currentParent.filterIdsReceived.find(filterIdsReceived => {
        return filterIdsReceived.filterIds.includes(filterValue)
      })
    })
  }
  if (!arrayOfNeededFiltersToReceive.length) {
    return false
  }
  if (!currentParent.filterIdsReceived) {
    currentParent.filterIdsReceived = [];
    return {
      arrayOfNeededFiltersToReceive,
      page: 0
    };
  } else {
    const existingFiltersRequest = currentParent.filterIdsReceived.find(filtersReceivedObject => {
      return isEqual(filtersReceivedObject.filterIds.sort(), arrayOfNeededFiltersToReceive.sort())
    });
    if (existingFiltersRequest) {
      if (existingFiltersRequest.allFeaturesWithFiltersReceived || !onScroll) { //!onScroll - UNSAFE_componentWillReceiveProps request
        return false
      } else {
        return existingFiltersRequest
      }
    } else {
      return {
        arrayOfNeededFiltersToReceive,
        page: 0
      };
    }
  }
};

export const getFeaturesFromBackendWithFilters = (featureGroup, counterTopFiltersIdsReceived, existingFilterObject = null) => {
  const filterObject = existingFilterObject || {
    uuid: uuid.v4(),
    filterIds: counterTopFiltersIdsReceived, // array of arrays, ex. [[56],[1122,1313]] etc.
    featuresReceived: 0,
    page: 0
  };
  if (!existingFilterObject) {
    featureGroup.filterIdsReceived.push(filterObject);
  }
  const featuresCountToReceive = 6000;
  featureGroup.requestInProgress = true;
  return getBvGroupFeatures(
    featureGroup.dbName || featureGroup.partName,
    filterObject.page,
    featuresCountToReceive,
    counterTopFiltersIdsReceived
  )
    .then((response) => {
      featureGroup.requestInProgress = false;
      if (response && response.length) {
        console.log("response.data with filters", response);
        featureGroup.setGroupFeatures(response, featuresCountToReceive, false, "", null, true);
        featureGroup.filterIdsReceived = featureGroup.filterIdsReceived.map((filtersReceivedObject) => {
          if (filtersReceivedObject.uuid === filterObject.uuid) {
            filtersReceivedObject.featuresReceived += response.length;
            if (response.length < featuresCountToReceive) {
              filtersReceivedObject.allFeaturesWithFiltersReceived = true;
            } else {
              filtersReceivedObject.page++;
            }
          }
          return filtersReceivedObject
        });
      }
      return response
    });
}

export const getSelectedFiltersLength = (filterGroup, selectedFilters) => {
  return selectedFilters.reduce((total, selectedFilter) => {
    return total + (filterGroup.id === selectedFilter.filterGroupId ? 1 : 0)
  }, 0)
}


/**
 * returns all available filter groups with values for featureGroup's part id
 * @param featureGroup {featureGroupInterface}
 * @param partId {string}
 * @param allFilterGroups {array}
 * @param shopNavItems {[navItemInterface]}
 * @param forceFromNavItems {boolean}
 * @returns {array}
 */
export const getAvailableFilters = (featureGroup, partId, allFilterGroups, shopNavItems = null, forceFromNavItems = false) => {
  const layout = getCurrentLayout();
  if (!featureGroup && partId) {
    featureGroup = layout.getFeatureGroupByPartId(partId)
  }
  if (featureGroup) {
    if (featureGroup.filtersReceived && !forceFromNavItems) {
      return getAvailableFiltersForReceivedFilters(featureGroup, allFilterGroups)
    }
    const navItems = shopNavItems || layout.designNavigationItems(
      {part: featureGroup},
      {},
      "",
      null,
      false,
      allFilterGroups
    );
    return getAvailableFiltersForNavItems(navItems, allFilterGroups)
  }
  return []
}

/**
 * returns all available filter groups for featureGroup
 * @param featureGroup {featureGroupInterface}
 * @param shopNavItems {[navItemInterface]}
 * @returns {[filterGroupInterface]}
 */
export const getFeatureGroupFilters = (featureGroup,  shopNavItems = null) => {
  if (!featureGroup) {
    return []
  }
  const {selectedFilters, filterGroups} = store.getState().filterState;
  if (!featureGroup.filtersReceived && !featureGroup.realFeaturesReceived && !featureGroup.filtersRequested) {
  // && !featureGroup.realFeaturesReceived
    featureGroup.filtersRequested = true;
    getBvGroupFilterValues(featureGroup.dbName || featureGroup.partName, null, false)
      .then((featureGroupFiltersResponse) => {
        setActivePartFilterValues(featureGroupFiltersResponse.data, featureGroup, filterGroups);
        store.dispatch(updateFiltersCount());
      });
  }
  const availableFilters = getAvailableFilters(featureGroup, "", filterGroups, shopNavItems);
  // we are using this in sqft calc
  // if (!IS_LIXIL_UI) { // might need to change this, but for now we hardcode filters for all profiles
  //   return availableFilters
  // }
  return getHardCodedFilterGroups(availableFilters, featureGroup.partId, selectedFilters)
}

export const getFilterTranslate = (f, intl) => {
  const displayTrimmed = f.displayText ? f.displayText.trim() : "";
  const valueTrimmed = f.value ? f.value.trim() : "";

  return displayTrimmed && intl.messages[displayTrimmed]
    ? intl.formatMessage({id: displayTrimmed})
    : valueTrimmed && intl.messages[valueTrimmed]
      ? intl.formatMessage({id: valueTrimmed})
      : displayTrimmed || valueTrimmed || ""
}
